<fc-search-input
  [label]="'PROBLEM.LABEL' | translate"
  [control]="control"
  [options]="options"
  [search]="search"
  [displayWith]="displayWith"
  [showSearchIcon]="showSearchIcon"
  [requiredMark]="requiredMark"
  [preloadOptions]="preloadOptions"
  [searchOnFocus]="searchOnFocus"
  [translateErrorPrefix]="translateErrorPrefix"
></fc-search-input>
